function PortfolioSectionWrapper({ children, heading, headingColor }) {
  return (
    <div className="portfolio-section">
      <div className="portfolio-heading">
        <h1 style={{ color: headingColor }}>{heading}</h1>
      </div>
      {children}
    </div>
  );
}

export default PortfolioSectionWrapper;
